module.exports = __webpack_public_path__ + "static/media/ecgCheck.0104a3ca.mp3";